import React from 'react';
import { LogOut, MonitorSmartphone, ShieldAlert, ShieldOff } from 'lucide-react';
import './RootSessionOverlay.css';

const NOTICE_VISUALS = {
  SESSION_REPLACED: { icon: MonitorSmartphone, tag: 'Device change detected' },
  IP_BLOCKED: { icon: ShieldOff, tag: 'Network access revoked' },
  IP_NOT_APPROVED: { icon: ShieldOff, tag: 'Network access revoked' },
  SESSION_REVOKED: { icon: ShieldAlert, tag: 'Session ended' },
};

export default function RootSessionOverlay({ notice, countdown }) {
  if (!notice) return null;
  const visual = NOTICE_VISUALS[notice.code] || NOTICE_VISUALS.SESSION_REVOKED;
  const Icon = visual.icon;

  return (
    <div className="ozso-overlay" role="alertdialog" aria-modal="true" aria-live="assertive">
      <div className="ozso-modal">
        <div className="ozso-modal__accent" aria-hidden="true" />

        <div className="ozso-modal__badge">
          <Icon size={26} strokeWidth={2.2} />
        </div>

        <span className="ozso-modal__tag">{visual.tag}</span>
        <h2 className="ozso-modal__title">{notice.title}</h2>
        <p className="ozso-modal__message">{notice.message}</p>

        <div className="ozso-modal__footer">
          <div className="ozso-modal__signing">
            <LogOut size={14} strokeWidth={2.4} />
            <span>Signing out in {countdown}s…</span>
          </div>
          <div className="ozso-modal__progress">
            <div className="ozso-modal__progress-bar" key={notice.code} />
          </div>
        </div>
      </div>
    </div>
  );
}